import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import Textarea from '@/components/ui/Textarea';
import Button from '@/components/ui/Button';
import ImageUpload from '@/components/ui/ImageUpload';

const empty = { name: '', categoryId: '', brand: '', imageUrl: '', description: '' };

/** Form de equipamento reutilizado por admin (global) e trainer (próprio). */
export default function EquipmentForm({ initial, categories = [], onSubmit, onCancel }) {
  const { t } = useTranslation();
  const [form, setForm] = useState({ ...empty, ...initial, categoryId: initial?.categoryId ?? '' });
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return setErr(t('equipments.errName'));
    setSaving(true);
    setErr(null);
    try {
      const { category, ...payload } = form;
      await onSubmit({ ...payload, categoryId: form.categoryId ? Number(form.categoryId) : null });
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} style={{ display: 'grid', gap: 'var(--space-4)' }}>
      <Input label={t('equipments.fieldName')} value={form.name} onChange={set('name')} placeholder={t('equipments.namePlaceholder')} />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-3)' }}>
        <Select label={t('equipments.fieldCategory')} value={String(form.categoryId ?? '')} onChange={set('categoryId')}
          options={[{ value: '', label: '—' }, ...categories.map((c) => ({ value: String(c.id), label: c.name }))]} />
        <Input label={t('equipments.fieldBrand')} value={form.brand} onChange={set('brand')} placeholder={t('equipments.brandPlaceholder')} />
      </div>
      <ImageUpload
        label={t('equipments.fieldImage')}
        folder="equipments"
        value={form.imageUrl}
        onChange={(url) => setForm((f) => ({ ...f, imageUrl: url }))}
      />
      <Input label={t('equipments.fieldImageUrl')} value={form.imageUrl} onChange={set('imageUrl')} placeholder="https://..." />
      <Textarea label={t('equipments.fieldDescription')} value={form.description} onChange={set('description')} rows={3} />
      {err && <span style={{ color: 'var(--danger)', fontSize: 13 }}>{err}</span>}
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
        <Button type="button" variant="ghost" onClick={onCancel}>{t('common.cancel')}</Button>
        <Button type="submit" loading={saving}>{t('common.save')}</Button>
      </div>
    </form>
  );
}
